module.exports = __webpack_public_path__ + "img/paper_towel.8672e56d.svg";